import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';


export class SkyDefinitionListHeadingComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-definition-list-heading',
  template: `<div class="sky-subsection-heading sky-definition-list-heading">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-definition-list-heading {
  margin-bottom: 5px;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
